import { useEffect, useState } from 'react';

const usePerformanceMonitor = () => {
  const [metrics, setMetrics] = useState({
    lcp: null,
    fid: null,
    cls: null,
    fcp: null,
    ttfb: null,
    inp: null
  });

  const [performanceScore, setPerformanceScore] = useState(null);

  useEffect(() => {
    // Carica la libreria web-vitals solo quando necessaria
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB, getINP }) => {
      // Collect Core Web Vitals
      getCLS((metric) => {
        setMetrics(prev => ({ ...prev, cls: metric.value }));
      });

      if (getFID) {
        getFID((metric) => {
          setMetrics(prev => ({ ...prev, fid: metric.value }));
        });
      } else {
        getINP((metric) => {
          setMetrics(prev => ({ ...prev, inp: metric.value }));
        });
      }

      getFCP((metric) => {
        setMetrics(prev => ({ ...prev, fcp: metric.value }));
      });

      getLCP((metric) => {
        setMetrics(prev => ({ ...prev, lcp: metric.value }));
      });

      getTTFB((metric) => {
        setMetrics(prev => ({ ...prev, ttfb: metric.value }));
      });
    }).catch(error => {
    });

    // Monitor custom performance metrics
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        // Monitor navigation timing
        if (entry.entryType === 'navigation') {
          const navigationTiming = entry;
        }

        // Monitor resource timing for large resources
        if (entry.entryType === 'resource' && entry.transferSize > 50000) {
        }
      });
    });

    // Observe navigation and resource entries
    try {
      observer.observe({ entryTypes: ['navigation', 'resource'] });
    } catch (error) {
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  // Calcola un punteggio di performance basato sui Core Web Vitals
  useEffect(() => {
    const { lcp, fid, cls, inp } = metrics;

    if ((lcp !== null && fid !== null && cls !== null) ||
        (lcp !== null && inp !== null && cls !== null)) {
      let score = 100;

      // LCP scoring (buono: < 2.5s, migliorabile: 2.5-4s, scarso: > 4s)
      if (lcp > 4000) score -= 40;
      else if (lcp > 2500) score -= 20;

      // FID/INP scoring (buono: < 100ms, migliorabile: 100-300ms, scarso: > 300ms)
      const interactionMetric = fid !== null ? fid : inp;
      if (interactionMetric > 300) score -= 40;
      else if (interactionMetric > 100) score -= 20;

      // CLS scoring (buono: < 0.1, migliorabile: 0.1-0.25, scarso: > 0.25)
      if (cls > 0.25) score -= 20;
      else if (cls > 0.1) score -= 10;

      setPerformanceScore(Math.max(0, score));
    }
  }, [metrics]);

  // Funzione per ottimizzazioni automatiche
  const applyAutoOptimizations = () => {
    // Reduce animations se le performance sono basse
    if (performanceScore && performanceScore < 60) {
      document.documentElement.style.setProperty('--animation-duration', '0.1s');
      document.body.classList.add('reduce-motion');
    }

    // Lazy load di immagini non critiche
    const images = document.querySelectorAll('img:not(.critical-image)');
    images.forEach(img => {
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  };

  return {
    metrics,
    performanceScore,
    applyAutoOptimizations
  };
};

export default usePerformanceMonitor;